import { useFlags } from 'launchdarkly-react-client-sdk';

export const showDashboard = pathname => !/^\/(onboarding)/.test(pathname);

export const createMenuItemProps = (title, description, path, absolute, imageSrc, onClick) => ({
  title,
  description,
  path,
  absolute,
  imageSrc,
  onClick
});

export const useTabsPathsMap = () => {
  const { showDesignTabFeTemp102521: showProductsTab } = useFlags();
  const { enableRedeemPagesManagementFeatureOnDashboardTemp060322: redeemPages } = useFlags();

  const productsTab = showProductsTab ? { Products: '/products' } : undefined;
  const redeemPagesTab = redeemPages ? { Redeem: '/redeem-pages' } : undefined;

  return {
    Dashboard: '/',
    ...productsTab,
    Orders: '/orders',
    Inventory: '/inventory?inventory=available',
    Shipments: '/shipments',
    ...redeemPagesTab
  };
};

export const packsMenuItemList = [
  createMenuItemProps(
    'Build A Pack',
    'Create your own custom pack',
    '/custom-swag-packs/catalog',
    false,
    '/images/public/build-pack.svg'
  ),
  createMenuItemProps(
    'Preset Packs',
    'Select one of our preset packs',
    '/preset-packs/',
    false,
    '/images/public/preset-pack.svg'
  )
];

export const productMenuItemList = [
  ...packsMenuItemList,
  createMenuItemProps('Bulk Swag', 'Get products in bulk', '/bulk/catalog', false, '/images/public/bulk-swag.svg')
];

export const companyMenuItemList = [
  createMenuItemProps('About Us', 'Get to know SwagUp', '/company', true, '/images/public/about-us.svg'),
  createMenuItemProps('Blog', 'Read SwagUp related articles', '/blog', true, '/images/public/blog.svg'),
  createMenuItemProps('FAQ', 'Frequently Asked Questions', '/faq', true, '/images/public/faq.svg')
];

export const platformMenuItemList = [
  createMenuItemProps('Services', 'The SwagUp process', '/services', true, '/images/public/services.svg'),
  createMenuItemProps(
    'Redeem Pages',
    'Automate swag fulfillment',
    '/blog/redeem-pages-guide',
    true,
    '/images/public/redeemPages.svg'
  ),
  createMenuItemProps(
    'Turn Times',
    'Fulfillment times',
    'https://launch.swagup.com/fulfillment-performance',
    true,
    '/images/public/turn-times.svg'
  )
];
